<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-title class="text-h5 orange darken-3 white--text"> Generar nueva factura DGI {{ is_pruebas?'(modo pruebas)':'' }} </v-card-title>

        <v-card-text class="pt-4">  
          <template>
            <v-data-table
              :headers="headers"
              :items="recibo.detalle"
              :items-per-page="300" 
              hide-default-footer
              class="elevation-2 mb-4 pa-2"
              dense
            >
            <template v-slot:[`item.concepto`]="{ item }">
              <span>
                {{ programa.nombre_compuesto }}
              </span>
            </template>
          </v-data-table>
          </template> 

          <div class="row">
            <div class="col mb-0 pb-0">
              <v-text-field v-model.trim="ruc" :disabled="loading" label="Ingresar RUC/Documento/Pasaporte:" filled append-icon="mdi-eye" @input="changeruc" @click:append="buscarruc" hide-details />
            </div>
            <div class="col mb-0 pb-0">
              <v-text-field v-model.trim="filtros.razon" label="Ingresa la razon social:" filled append-icon="mdi-account" dense hide-details v-show="ruc_data.type" />
            </div> 
          </div>

          <div class="row">
            <div class="col py-0">
              <p class="my-0 py-0"> nombre: {{ ruc_data.name }} </p>
              <p class="my-0"> tipo: {{ ruc_data.ruc_type_display }} </p>
            </div>
            <div class="col py-0">
              <p class="my-0 py-0"> receptor: {{ ruc_data.type }} </p>
              <p class="my-0"> {{ ruc_data.type_display }} </p>
            </div>
            <div class="col py-0">
              <p class="my-0 py-0"> dv: {{ ruc_data.dv }} </p> 
            </div>
          </div> 
          <div class="row" v-show="ruc_data.type"> 
            <div class="col">
              <v-select filled :items="getTiposPersonas()" v-model="filtros.tipo_receptor" :disabled="!editar_tipo_receptor" label="tipo receptor:" return-object dense hide-details />  
            </div>
            <div class="col">
              <v-select filled :items="getTipoPagos()" v-model="filtros.tipo_pago" label="forma de pago:" return-object dense hide-details />
            </div>
          </div> 
          <div class="row" v-show="ruc_data.type" v-if="ruc_sin_dv && filtros.tipo_receptor && (filtros.tipo_receptor.id=='01')"> 
            <div class="col mt-0 mb-4 py-0"> 
              <v-text-field v-model.trim="ruc_data.dv" label="Digito verificador DV obligatorio si es Contribuyente:" filled prepend-icon="mdi-key" placeholder="Ingresa el digito verificador del RUC" dense hide-details />
            </div>
          </div> 
          <div class="row" v-show="ruc_data.type"> 
            <div class="col mt-0 mb-4 py-0">
              <v-text-field v-model.trim="filtros.direccion" label="Ingresa la direccion del destinatario:" filled append-icon="mdi-map" dense hide-details />
            </div>
          </div> 
          <div class="row" v-show="ruc_data.type"> 
            <div class="col my-0 py-0">
              <v-text-field v-model.trim="filtros.email" type="email" label="Ingresa el correo del destinatario (para la factura):" filled append-icon="mdi-email" dense hide-details class="pb-0 mb-0" />
              <v-checkbox v-model="enviar_correo" color="orange" label="Enviar factura al correo" class="py-0 my-0" />
            </div>
          </div> 

          <div v-if="filtros.tipo_receptor && filtros.tipo_receptor.id == '01'">
            <p class="mb-1 mt-4 orange--text">Debe seleccionar provincia-distrito-corregimiento para este tipo de RUC:</p>
              <div class="row">
                  <div class="col">
                    <v-select filled :items="filtros.provincias" v-model="filtros.provincia" label="Provincia" item-text="provincia" @input="selprovincia" return-object dense hide-details />
                  </div>
                  <div class="col">
                    <v-select filled :items="filtros.distritos" v-model="filtros.distrito" label="Distrito" item-text="distrito" @input="seldistrito" return-object dense hide-details />
                  </div>
                  <div class="col">
                    <v-select filled :items="filtros.corregimientos" v-model="filtros.corregimiento" label="Corregimiento" item-text="corregimiento" return-object dense hide-details />
                  </div>
              </div>
              <p class="mt-1" v-if="filtros.corregimiento">
                codigo de ubicacion seleccionada: {{ filtros.corregimiento.codigo }}
              </p>
          </div>
          <div v-if="filtros.tipo_receptor && filtros.tipo_receptor.id == '04'">
            <p class="mb-1 mt-4 orange--text">Debe seleccionar el pais del extranjero:</p>
            <div class="row">
                <div class="col">
                    <v-select filled :items="paises" v-model="country_extranjero" label="Pais del extranjero (con relacion a Panamá)" item-text="nombre" return-object dense hide-details />
                </div>
            </div>
          </div>
          <p class="text-center mt-8" v-if="msg">  {{ msg }} </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" :loading="loading || loading_fact_bk" :disabled="facturado || hide_btn_facturar" dark @click="enviar()"> {{ ruc_data.type?'Generar facturar':'Consultar Ruc' }} </v-btn>
          <v-btn color="grey" :loading="loading" outlined tile @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ver_factura_ispi ref="refver_factura_ispi"/>
  </div>
</template>

<script>
import { send_email } from './email';
import { apifacturar, guardarFacturaNulRecibo, pruebas } from './facturafacil';
import { buscar_ruc } from './findruc';
import { pronvincias_dgi } from './provincias';
import { getdata, getTipoPagos,getTiposPersonas, limpiarObjeto } from './utils';
import ver_factura_ispi from './ver_factura_ispi.vue';

// NOTA: desde 18 noc 2025 se puso en prod la facturacion electronica del portal con la DGI
import {FACTURAS_BASE_PATH} from './facturafacil';
import { todosLosPaises } from '../factura_upi/paises';

  export default {
    components:{ver_factura_ispi},
    data() {
      return {
        loading: true,
        dialog: false,
        hide_btn_facturar: false,
        facturado: false,
        enviar_correo: false,
        editar_tipo_receptor: true,
        loading_fact_bk: false,
        ruc_sin_dv: true,
        ruc: '',
        msg: '',
        ruc_data: {},
        recibo: {},
        estudiante: {},
        programa: {},
        sucursal: {},
        facturar: {},
        getTipoPagos,
        getTiposPersonas,
        headers:[
          { text: '', value: '' },
          { text: 'Concepto', value: 'concepto' },
          { text: 'Cuota', value: 'numero_cuota' },
          { text: 'Cantidad', value: 'cantidad' },
          { text: 'Monto', value: 'monto' },
          { text: 'Subtotal', value: 'sub_total' },
          { text: 'Unidad Medidad', value: 'unidad_medida_nombre' },
        ],
        country_extranjero: null,
        paises: todosLosPaises,
        filtros:{
          provincia: null,
          distrito: null,
          corregimiento: null,
          email:'',
          direccion:'',
          razon: '',
          tipo_pago: getTipoPagos().find(x=>x.id==8),
          tipo_receptor: getTiposPersonas().find(x=>x.id=='02'),

          provincias: [],
          distritos: [],
          corregimientos: [],
        },
        is_pruebas: pruebas
      };
    },
    methods: {
      async openmodal(rec,suc, estudent, progra) {
        window.console.log('abrir modal factura dgi:', rec, suc, estudent, progra);
        rec.detalle.map((x)=>{
          x.monto = Math.round(parseFloat(x.monto) * 100) / 100
        })

        // let fecha_emision_for_factura = ''''
        const fechaStr = rec.fecha_registro
        if (typeof fechaStr !== "string") { 
          this.$root.$notify.show('la fecha de emision no es valida', {color:'red',x: 'right',});
          return  
        }

        const partes = fechaStr.split(" ");
        if (partes.length === 0 || !/^\d{4}-\d{2}-\d{2}$/.test(partes[0])) { 
          this.$root.$notify.show('la fecha de emision no es valida', {color:'red',x: 'right',});
          return 
        } 
        
        this.dialog = true;
        this.hide_btn_facturar = false;
        this.recibo = rec;
        this.sucursal = suc;
        this.estudiante = estudent
        this.programa = progra
        this.loading = false
        this.facturado = false
        this.ruc_data = {}
        this.country_extranjero = null
        this.msg = ''
        this.ruc = this.recibo.numero_documento_depositante
        this.filtros.email = this.estudiante.email
        this.filtros.direccion = this.estudiante.domicilio

        this.facturar = getdata(rec, suc, progra)
        this.filtros.provincias = pronvincias_dgi

        // guardarFacturaNulRecibo(47,this.recibo.id)  
        // this.verificarCopiaFactura(rec.id)
        this.enviar_al_correo_check(progra)
      },
      cerrar() {
        this.dialog = false;
      },
      /* async verificarCopiaFactura(reciboid){
        this.loading_fact_bk = true
        const r = await getBackup(reciboid) 
        this.loading_fact_bk = false
        if(r && r.data && r.data.facturas_vinculadas){
          const res = r.data.facturas_vinculadas;
          if(res.length==0) return
          const recvinc = res[0]
          window.console.log('<><><>', res);
          
          this.$refs.refver_factura_ispi.openmodal(recvinc)
          this.cerrar()
        }
        
      }, */
      enviar_al_correo_check(prog){
        const unidad = this.$store.state.CARGO.sede.unidad_negocio
        const univ = prog.universidad ? prog.universidad.id : -1 
        if(unidad ==15 && univ == 301){
          this.enviar_correo = true
        }
      },
      selprovincia(p){
        const prov = this.filtros.provincias.find(x=>x.provincia==p.provincia).distritos
        this.filtros.distritos = prov
        this.filtros.corregimiento = null
        this.filtros.provincia = null
        window.console.log('selprovincia:', prov); 
      },
      seldistrito(p){ 
        window.console.log('seldistrito:', p,this.filtros.distrito); 
        this.filtros.corregimiento = null 
        this.filtros.corregimientos = this.filtros.distrito.corregimientos
      },

      changeruc(){
        this.msg = ''
        this.ruc_data = {}
        this.editar_tipo_receptor = true 
        this.filtros.tipo_receptor = getTiposPersonas().find(x=>x.id=='02')
      },

      async buscarruc(){
        if(!this.ruc){
          this.$root.$notify.show(`Ingrese un RUC.`, {color:'red',x: 'right',});
          return 
        }

        this.loading = true
        this.editar_tipo_receptor = true
        const unidad = this.$store.state.CARGO.sede.unidad_negocio
        const sedeid = this.recibo.sede_id

        const r = await buscar_ruc(this.ruc,unidad, sedeid)
        this.loading = false 
        if(r && r.ruc) { 
          this.ruc_data = r
          this.facturar.document.receptor.name = r.name
          this.facturar.document.receptor.ruc = r.ruc
          this.facturar.document.receptor.dv = r.dv
          this.facturar.document.receptor.ruc_type = r.ruc_type
          this.facturar.document.receptor.type = r.type
          this.filtros.razon = r.name 
          if( r.type == '01' ) {
            this.editar_tipo_receptor = false
            if(r.dv) this.ruc_sin_dv = false
            else this.ruc_sin_dv = true
          }
        }else{
          this.filtros.razon = this.recibo.nombre_depositante 
          this.facturar.document.receptor.ruc = this.ruc
          this.facturar.document.receptor.ruc_type = '1' // natural
          this.facturar.document.receptor.dv = null 
          this.facturar.document.receptor.location = null 
          this.facturar.document.receptor.type = '02'
          this.ruc_data.type = '02'
          this.ruc_sin_dv = true
          this.$root.$notify.show(`RUC no encontrado o invalido`, {color:'red',x: 'right',});
          this.msg = 'RUC no encontrado o invalido, puede continuar con factura de consumidor final NO contibuyente.'
        }  
        const tp = this.facturar.document.receptor.type
        this.filtros.tipo_receptor = getTiposPersonas().find(x=>x.id==tp)
      },
      async enviar() {
        if(!this.ruc_data.type){
          this.buscarruc()
          return
        }

        if(!this.filtros.corregimiento && this.facturar.document.receptor.type == '01'){
          this.$root.$notify.show(`Seleccione ubicacion del receptor de la factura`, {color:'red',x: 'right',});
          return 
        }

        if(this.filtros.tipo_receptor && (this.filtros.tipo_receptor.id=='01' && !this.ruc_data.dv)){
          this.$root.$notify.show(`Ingresa el DV para este tipo de receptor.`, {color:'red',x: 'right',});
          return 
        }

        if(this.filtros.tipo_receptor.id=='01'){
          this.facturar.document.receptor.dv = this.ruc_data.dv
        }else if(this.filtros.tipo_receptor.id=='02') {
          this.facturar.document.receptor.dv = null 
        }

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!regex.test(this.filtros.email)){
          this.$root.$notify.show(`Ingresa un correo valido`, {color:'red',x: 'right',});
          return
        }

        /* if(!this.filtros.direccion){
          this.$root.$notify.show(`Ingresa la direccion del receptor de la factura`, {color:'red',x: 'right',});
          return 
        } */

        if(!this.filtros.direccion){
          this.filtros.direccion = '' // blank 
          if( this.facturar.document.receptor.type == '01' ){
            this.$root.$notify.show(`Ingresa la direccion del receptor de la factura, es un contribuyente`, {color:'red',x: 'right',});
            return
          }
        }

        if(this.filtros.tipo_receptor.id == '04' && !this.country_extranjero){
           this.$root.$notify.show(`Debe seleccionar el pais del extranjero`, {color:'red',x: 'right',});
           return
        }

        if(!this.filtros.razon){
          this.$root.$notify.show(`Ingresa la razon social del receptor de la factura`, {color:'red',x: 'right',});
          return 
        }
        
        if(!this.filtros.tipo_pago){
          this.$root.$notify.show(`Selecciona la forma de pago.`, {color:'red',x: 'right',});
          return 
        }
        if(!this.filtros.tipo_receptor){
          this.$root.$notify.show(`Selecciona el tipo de receptor.`, {color:'red',x: 'right',});
          return 
        }

        if(this.filtros.corregimiento){
          this.facturar.document.receptor.location = this.filtros.corregimiento.codigo
        }
        this.facturar.document.receptor.email = this.filtros.email
        this.facturar.document.receptor.address = this.filtros.direccion
        this.facturar.document.receptor.name = this.filtros.razon
        this.facturar.document.receptor.type = this.filtros.tipo_receptor.id
        this.facturar.document.payments[0].type = this.filtros.tipo_pago.id
        if(this.country_extranjero){
          this.facturar.document.receptor.country = this.country_extranjero.codigo 
        }
        this.msg = ''

        
        let a = 0 
        if(a==0){ 
          this.loading = true
          const limpio = limpiarObjeto(this.facturar)
          const unidad = this.$store.state.CARGO.sede.unidad_negocio
          const sedeid = this.recibo.sede_id

          const r = await apifacturar(limpio,unidad,sedeid)
          this.loading = false
          window.console.log('factura creada::', r);
          if(r && r.pdf_url){
            this.hide_btn_facturar = true
            this.msg = 'facturado, generando el pdf...'
            this.loading = true 

            await guardarFacturaNulRecibo(this, r, this.recibo, this.ruc)

            // const pdfurl = r.pdf_url.replaceAll('https://backend-qa-api.facturafacil.com.pa',FACTURAS_BASE_PATH+'/proxy')
            const pdfurl = r.pdf_url
              .replaceAll('https://backend-qa-api.facturafacil.com.pa', FACTURAS_BASE_PATH + '/proxy')
              .replaceAll('https://api.facturafacil.com.pa', FACTURAS_BASE_PATH + '/proxy')

            const response = await fetch(pdfurl);
            if (!response.ok) {
              this.$emit('fact_dgi_success')
              this.loading = false
              this.msg = 'facturado, pero hubo error al generar el pdf, reporte este caso, posiblemente la factura no esta vinculado al recibo.'
              // throw new Error("Error en la descarga");
              return;
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = this.filtros.razon+"-factura.pdf";
            document.body.appendChild(link);
            link.click(); 
            link.remove();
            URL.revokeObjectURL(url);
            this.loading = false
            this.facturado = true
            this.msg = ''
            let txt = 'Factura generada '

            if(this.enviar_correo){
              this.msg = 'enviando factura al correo ...'

              const c = await send_email(this.filtros.email,r.cufe,unidad,sedeid) 
              if(c) {this.msg = c.detail; txt += c.detail}
            }

            this.$emit('fact_dgi_success')
            this.$root.$notify.show(txt, {
              color: 'green',
              x: 'right',
              timeout: 10000
            });
            this.dialog = false

          }else {
            window.console.log('logggg', JSON.stringify(r));
            this.$root.$notify.show(r.message, {color:'red',x: 'right',});            
          }
        }else{
          alert('En desarrollo :)')
        }

      },
    },
  };
</script>
